import AppHeader from './Header';
import AppFooter from './Footer';

export default {
	AppHeader,
	AppFooter
}


// WEBPACK FOOTER //
// ./src/components/layouts/index.js